import { createInterpolatedTranslationKey, TranslatableText } from '@dreryk/react-common';

import { translationKeys } from '../translations';

const SECONDS_IN_MINUTE = 60;
const SECONDS_DIGITS = 2;

export const getElapsedTimeParts = (totalSeconds: number): { minutes: string; seconds: string } => ({
   minutes: String(Math.floor(totalSeconds / SECONDS_IN_MINUTE)),
   seconds: String(totalSeconds % SECONDS_IN_MINUTE),
});

export const formatElapsedTime = (totalSeconds: number): TranslatableText => {
   const { minutes, seconds } = getElapsedTimeParts(totalSeconds);

   return createInterpolatedTranslationKey(translationKeys.mainMenuTileItem.elapsedTime, {
      minutes: minutes,
      seconds: seconds.padStart(SECONDS_DIGITS, '0'),
   });
};
